module.exports = __webpack_public_path__ + "static/media/live.d96501bd.svg";